import React from "react";
const FormState = React.createContext({
    isLoading: null,
    salutation: null,
    first: null,
    last: null,
    gender: null,
    dob: null,
    imageupload: null,
    university: null,
    degree: null,
    timeFrom: null,
    timeTo: null,
    contact: null,
    linkedin: null,
    country: null,
    state: null,
    address: null,
    pincode: null,
    headline: null,
    position: null,
    company: null,
    designation: null,
    workFrom: null,
    workTo: null,
    location: null
});
export default FormState;